






























































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwPwInput extends SwExtendedVue {
  /* two way binding for main v-model */
  @Prop(String)
  value: string;

  internalValue: string | number | boolean = this.value;
  @Watch('value')
  onValueChange(val: string) {
    this.internalValue = val;
  }
  @Watch('internalValue')
  onInternalValueChange() {
    this.$emit('input', this.internalValue);
  }

  mounted() {
    const inputEl = this.$refs.password as HTMLElement;
    if (inputEl) { inputEl.focus(); }
  }

  focused: boolean = false;
  type: string = 'password';
  public focus() {
    const inputEl = this.$refs.input as HTMLElement;
    if (inputEl) { inputEl.focus(); }
  }
}
